import React, { useState } from 'react';
import { Fade, IconButton, Menu, MenuItem } from '@material-ui/core';
import AppsIcon from '@material-ui/icons/Apps';

const options = [
  {
    name: 'Digital Study Models (DSM)',
    url: process.env.REACT_APP_DSM_URL
  }
];

const AppSwitch = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    const selectedOption = options[index];
    window.open(selectedOption.url, '_blank');

    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton color="inherit" title="Switch Applications" onClick={handleClick}>
        <AppsIcon />
      </IconButton>

      <Menu
        id="apps-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        TransitionComponent={Fade}
        style={{ marginTop: 36 }}
      >
        {options.map((option, i) => (
          <MenuItem key={i} onClick={event => handleMenuItemClick(event, i)}>
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default AppSwitch;
